import axios from "axios";

console.log(process.env.NODE_ENV);
export default process.env.NODE_ENV == "production"
    ? axios.create({
        //production 환경 (AWS EC2) - Nginx 프록시를 통해 백엔드 접근
        baseURL: "/api"
    })
    : axios.create({
        //development 환경
        baseURL: "http://localhost:8802",
        // baseURL: "https://wasBayerFarmSSO.zplab.co.kr"
        // baseURL: "https://was.farmpartner.bayer.co.kr"
    });